<template>
    <CCol v-bind="$attrs">
        <CInputCheckbox @update:checked="emitCheckbox" :checked.sync="checked">
            <template #label>
                <slot :name="label">{{ autoLabel }}</slot>
                <span v-if="required" class="text-danger">*</span>
            </template>

            <template v-for="(_, slot) in $slots">
                <template :slot="slot">
                    <slot :name="slot"></slot>
                </template>
            </template>
        </CInputCheckbox>
    </CCol>
</template>

<script>
export default {
    name: 'CCustomInputCheckbox',
    props: {
        disabled: {
            default: false,
            type: Boolean,
        },
        value: {

        },
        required: {
            default: false,
            type: Boolean
        },
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            checked: Boolean(this.value)
        }
    },
    computed: {
        autoLabel() {
            return this.label === '' ? this.name : this.label
        }
    },
    methods: {
        emitCheckbox() {
            this.checked = !this.checked
            this.$emit('input', this.checked)
            this.$emit('change', this.checked)
        }
    }
}
</script>